module.exports = __webpack_public_path__ + "static/media/img_client_fitt@2x.436a1eaf.png";